// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"eb4689de","703":"fc4bba96"}[chunkId] + ".chunk.js";
};